import { fetchQuery, graphql } from "relay-runtime"
import {
  AiRequestMetadataInput,
  chNextBestQuestionsQuery as chNextBestQuestionsQueryType,
} from "@/modules/chats/services/ai/ch/__generated__/chNextBestQuestionsQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query chNextBestQuestionsQuery($aiRequestMetadata: AiRequestMetadataInput!) {
    nextBestQuestions: ch_nextBestQuestions(aiRequestMetadata: $aiRequestMetadata) {
      questions
      result
      fileHash
      aiRequestDurationMs
      aiAnonymizationRequestDurationMs
    }
  }
`

export const chNextBestQuestionsQuery = (aiRequestMetadata: AiRequestMetadataInput) => {
  return fetchQuery<chNextBestQuestionsQueryType>(RelayEnvironment, query, { aiRequestMetadata }).toPromise()
}
